export default [
  {
    title: 'My Dashboard',
    icon: 'HomeIcon',
    route: 'csv-to-json',
  }
]